export default "__VITE_ASSET__BPeXvDE9__"